import type { TabularSheetCellValue } from '../../shared/tabular-sheet-payload.model';

export const DWT_PAYLOADS_FIXED_SHEET_COLUMNS = [
    { key: 'wasteTrackingId', header: 'Waste Tracking Id' },
    { key: 'yourReference', header: 'Your Reference' },
    { key: 'receivedAt', header: 'Received Date and Time' },
    { key: 'status', header: 'Status' },
    { key: 'errorsOrWarnings', header: 'Errors or Warnings' },
] as const;

export type DwtPayloadsFixedColumnKey = (typeof DWT_PAYLOADS_FIXED_SHEET_COLUMNS)[number]['key'];

export const DWT_PAYLOADS_FIXED_TABLE_HEADERS: readonly string[] = DWT_PAYLOADS_FIXED_SHEET_COLUMNS.map(
    (c) => c.header
);

export interface DwtPayloadsMappedRow {
    readonly wasteTrackingId: string;
    readonly yourReference: string;
    readonly receivedAt: string;
    readonly status: string;
    readonly errorsOrWarnings: string;
    readonly payloadColumns: Readonly<Record<string, TabularSheetCellValue>>;
}
